/* eslint-disable @typescript-eslint/no-unsafe-call */
import { Link, useLoaderData } from "@tanstack/react-router";
import ArticleCardList from "../components/articles/ArticleCardList";
import { Button } from "../components/ui/button";
import type { ArticleData } from "../api/api";

const ArticlesBrief = (): JSX.Element => {
	const { posts } = useLoaderData({
		from: "/(app)/_app/articles-brief",
	}) as unknown as { posts: Array<ArticleData> };

	return (
		<main className="py-3 px-safe-offset-3 min-h-[calc(100vh-176px)] overflow-x-hidden max-w-[890px] mx-auto">
			<div className="flex flex-col gap-3 pb-3">
				{posts?.length === 0 && (
					<h4 className="mb-4 text-center">
						W dniu dzisiejszym nie mamy artykułów do wyświetlenia
					</h4>
				)}
				{posts.map((post) => (
					<ArticleCardList
						key={post.ID + post.title}
						article={post}
					/>
				))}
			</div>
			<Link to="/articles">
				<Button
					className="w-full border-[1px] border-slate-200 bg-gradient-to-r from-[#0059FF] to-[#20314F] text-white"
					variant="ghost"
				>
					Zobacz wszystkie artykuły
				</Button>
			</Link>
		</main>
	);
};

export default ArticlesBrief;
